import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import ActionsModal from 'components/ActionsModal/ActionsModal'

import {
  selectDisplayedOrganization,
  updateDisplayedOrganization,
  closeDisplayedOrganization,
} from 'store/organizations'

import { selectOrganizations } from 'store/global'
import messages from './messages'

interface EditOrganizationModalProps {
  onSubmit: (organization: any) => void | Promise<void>
}

export default function EditOrganizationModal({ onSubmit }: EditOrganizationModalProps) {
  const dispatch = useDispatch()

  const allOrganizations = useSelector(selectOrganizations)
  const displayedOrganization = useSelector(selectDisplayedOrganization)

  const onFieldChange = (key: string, value: any) => dispatch(updateDisplayedOrganization({ key, value }))

  const onCloseModal = () => dispatch(closeDisplayedOrganization())

  const isOrganizationNameAvailable = (name: string): boolean =>
    allOrganizations.every((organization: any) =>
      organization.name !== name || organization.id === displayedOrganization?.id
    )

  const fields = {
    name: {
      key: 'name',
      isRequired: true,
      label: <FormattedMessage {...(messages.labels as any).name} />,
      validator: isOrganizationNameAvailable,
      formFeedback: <FormattedMessage {...(messages.formFeedback as any).nameUnavailable} />,
    }
  }

  return (
    <ActionsModal
      type='organization'
      mode='edit'
      item={displayedOrganization}
      primaryKey='name'
      fields={fields}
      onFieldChange={onFieldChange}
      onClose={onCloseModal}
      onSubmit={() => onSubmit(displayedOrganization)}
    />
  )
}

